import { trackingEvents } from '@global/monitoring/mixpanel';
import mixpanel from 'mixpanel-browser';
import { axiosInstances, getAxiosHeaders } from './config/axios';
import { routes } from './config/routes';

export const getPreStartQuestionList = async (formId: string, orgId: string) => {
  return axiosInstances.verificationV1
    ?.get(
      `${routes.transactions.purpose.getPreStartQuestionList}?formId=${formId}&orgId=${orgId}&id=${formId}&seed=${0}&count=${1000}`,
      getAxiosHeaders()
    )
    .then((res) => {
      if (res?.data?.code === 0) {
        return res?.data?.data?.list;
      }
      return false;
    })
    .catch(() => {
      return false;
    });
};

export const submitAnswersToPreStartQuestionList = async (
  obj: AnswersToPreStartQuestionList,
  mixpanelData: { question: string, answer: string | number | boolean }[]
) => {
  mixpanel.track(trackingEvents.form.events.addPurpose.started, mixpanelData);
  return axiosInstances.verificationV1
    ?.patch(routes.transactions.purpose.submitAnswersToPreStartQuestionList, obj, getAxiosHeaders())
    .then((res) => {
      if (res?.data?.code === 0) {
        mixpanel.track(trackingEvents.form.events.addPurpose.done, mixpanelData);
        return true;
      }
      mixpanel.track(trackingEvents.form.events.addPurpose.failed, mixpanelData);
      return false;
    })
    .catch(() => {
      mixpanel.track(trackingEvents.form.events.addPurpose.failed, mixpanelData);

      return false;
    });
};

interface AnswersToPreStartQuestionList {
  txnId: string; // or whatever type `searchedQuery.txnId` is
  data: QuestionAnswers;
  orgId: string; // or the type of `searchedQuery.orgId`
}

export type QuestionAnswers = Array<{
  questionId: string, // assuming `x.fieldName` is a string
  answer: string | number | boolean // depending on what type `val` can be
}>;
